import { msg } from "@lingui/core/macro";

export const startTimeBeforeTimeRuleMessages = {
	name: msg({ message: "Start Time Before Time" }),
	description: msg({ message: "Permit Start Time must be before time" }),
	errors: {
		isAfter: msg({ message: "Permit Start Time must be before {time}" }),
	},
} as const;
